import { render } from "./BlockAppointment.vue?vue&type=template&id=2a19d7c3&scoped=true"
import script from "./BlockAppointment.vue?vue&type=script&lang=js"
export * from "./BlockAppointment.vue?vue&type=script&lang=js"

import "./BlockAppointment.vue?vue&type=style&index=0&id=2a19d7c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a19d7c3"]])

export default __exports__